
// Inject the CSS inline
(function injectInlineStyles() {
  const css = `
    .submenu-hidden {
      display: none !important;
    }
    .tmenu_custom_arrow.open {
      transform: rotate(180deg);
      transition: transform 0.3s ease;
      margin-top: 0px!important;
    }
  `;
  const styleTag = document.createElement('style');
  styleTag.type = 'text/css';
  styleTag.id = 'inline-toggle-styles';
  styleTag.appendChild(document.createTextNode(css));
  document.head.appendChild(styleTag);
})();

// Your original toggle script below...
document.addEventListener('DOMContentLoaded', function () {
    function initLevel3Toggle() {
        const level2Items = document.querySelectorAll(
              '.tmenu_item_level_2.tmenu_item_has_child:not(.arrow-injected)'
                  );

                      level2Items.forEach(item => {
                            const link = item.querySelector('.tmenu_item_link');
                                  const submenu = item.querySelector('.tmenu_submenu');

                                        if (!link || !submenu) return;

                                              item.classList.add('arrow-injected');

                                                    const arrow = document.createElement('span');
                                                          arrow.className = 'tmenu_custom_arrow';
                                                                arrow.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';
                                                                      arrow.style.cursor = 'pointer';
                                                                            arrow.style.marginLeft = '6px';
                                                                                  arrow.style.marginTop = '4px';
                                                                                        // arrow.style.fontSize = '1em';
                                                                                              arrow.style.display = 'inline-block';

                                                                                                    const textSpan = link.querySelector('.tmenu_item_text');
                                                                                                          if (textSpan) {
                                                                                                                  textSpan.appendChild(arrow);
}
       else {
        link.appendChild(arrow);
      }

      submenu.classList.add('submenu-hidden');

      arrow.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        submenu.classList.toggle('submenu-hidden');
        arrow.classList.toggle('open');
      });
    });
  }

  let attempts = 0;
  function waitForQikify() {
    const menuReady = document.querySelector('.tmenu_item_level_2');
    if (menuReady || attempts >= 20) {
      initLevel3Toggle();
    } else {
      attempts++;
      setTimeout(waitForQikify, 300);
    }
  }

  waitForQikify();
});
